import { Component, OnInit } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { AuthService } from '@smartflip/authentication';
import { PRIVACY_POLICY_URL } from '@smartflip/data-constants';
import packageJson from './../../../../../../../apps/app/package.json';
import { menuItems } from './menu.constants';

@Component({
  selector: 'smartflip-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [IonicModule, RouterModule],
})
export class MenuComponent implements OnInit {
  public version: string = '';
  public year: number = new Date().getFullYear();
  public privacyUrl = PRIVACY_POLICY_URL;
  public menuLinkItems = menuItems;

  constructor(
    private auth: AuthService /*  private appVersion: AppVersion */,
  ) {}

  noFocus(evt: Event) {
    (evt.target as HTMLElement).blur();
  }

  signOut() {
    this.auth.signOut();
  }

  ngOnInit() {
    this.version = packageJson.version;
  }
}
